(function () {
  var STORAGE_KEY = 'favoriteProducts';

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveFavorites(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isFavorite(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var list = getFavorites();
    var index = list.indexOf(handle);
    if (index !== -1) {
      list.splice(index, 1);
    } else {
      list.push(handle);
    }
    saveFavorites(list);
    return list.indexOf(handle) !== -1;
  }

  function forceButtonStyle(btn) {
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('position', 'relative', 'important');
    btn.style.setProperty('vertical-align', 'middle', 'important');
    btn.style.setProperty('top', '-1px', 'important');
    btn.style.setProperty('margin', '0 0 0 6px', 'important');
    btn.style.setProperty('z-index', '2', 'important');
    btn.style.setProperty('width', '18px', 'important');
    btn.style.setProperty('height', '18px', 'important');
    btn.style.setProperty('min-width', '18px', 'important');
    btn.style.setProperty('min-height', '18px', 'important');
    btn.style.setProperty('max-width', '18px', 'important');
    btn.style.setProperty('max-height', '18px', 'important');
    btn.style.setProperty('border-radius', '50%', 'important');
    btn.style.setProperty('background', 'transparent', 'important');
    btn.style.setProperty('border', 'none', 'important');
    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    btn.style.setProperty('padding', '0', 'important');
    btn.style.setProperty('box-shadow', 'none', 'important');
    btn.style.setProperty('flex', '0 0 auto', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('opacity', '1', 'important');

    var svg = btn.querySelector('svg');
    if (svg) {
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.style.setProperty('width', '16px', 'important');
      svg.style.setProperty('height', '16px', 'important');
      svg.style.setProperty('flex', '0 0 auto', 'important');
      svg.style.setProperty('stroke-width', '2', 'important');
      svg.style.setProperty('display', 'block', 'important');
    }
  }

  function updateButtonState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var active = isFavorite(handle);
    btn.classList.toggle('is-active', active);

    var svg = btn.querySelector('svg');
    if (svg) {
      svg.style.setProperty('fill', active ? '#e0245e' : 'none', 'important');
      svg.style.setProperty('stroke', active ? '#e0245e' : '#333', 'important');
    }
  }

  function isRenderedVisible(el) {
    var rect = el.getBoundingClientRect();
    // 画面読み上げ専用などの「1pxだけの隠し要素」トリックを弾く
    if (rect.width < 4 || rect.height < 4) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function matchesTitle(el, titleText) {
    if (el.hasAttribute('data-favorite-button')) return false;
    if (el.classList.contains('visually-hidden')) return false;
    if (!isRenderedVisible(el)) return false;
    return el.textContent.trim() === titleText;
  }

  function findTitleElement(scope, titleText) {
    if (!titleText) return null;

    // h1 → h2 → h3 の優先順で探す。sticky-add-to-cart(画面下部の固定バー)など
    // 複製されたタイトルは除外する
    var tagOrder = ['h1', 'h2', 'h3'];
    for (var t = 0; t < tagOrder.length; t++) {
      var headings = scope.querySelectorAll(tagOrder[t]);
      for (var i = 0; i < headings.length; i++) {
        var el = headings[i];
        if (el.className && el.className.indexOf('sticky') !== -1) continue;
        if (matchesTitle(el, titleText)) {
          return el;
        }
      }
    }

    // 見出しが見つからない場合は、それ以外の要素から探す(商品一覧カード用)
    var candidates = scope.querySelectorAll('a, span, p, div');
    var best = null;
    candidates.forEach(function (el) {
      if (el.className && el.className.indexOf('sticky') !== -1) return;
      if (matchesTitle(el, titleText)) {
        if (!best || el.children.length < best.children.length) {
          best = el;
        }
      }
    });
    return best;
  }

  function findScope(btn) {
    return (
      btn.closest('product-card, .product-card, [class*="product-card"]') ||
      btn.closest('product-info, [class*="product-info"], .product, main') ||
      document.body
    );
  }

  function placeNextToTitle(btn) {
    if (btn.dataset.favoritePlaced === 'true') return;

    var scope = findScope(btn);
    var titleText = btn.getAttribute('data-product-title') || '';
    var titleEl = findTitleElement(scope, titleText.trim());

    if (titleEl) {
      titleEl.appendChild(btn);
      btn.dataset.favoritePlaced = 'true';
    }
  }

  function initButtons() {
    var buttons = document.querySelectorAll('[data-favorite-button]');
    buttons.forEach(function (btn) {
      if (!btn.dataset.favoriteInit) {
        btn.dataset.favoriteInit = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var handle = btn.getAttribute('data-product-handle');
          toggleFavorite(handle);
          updateButtonState(btn);
        });
      }
      placeNextToTitle(btn);
      forceButtonStyle(btn);
      updateButtonState(btn);
    });
  }

  document.addEventListener('DOMContentLoaded', initButtons);
  document.addEventListener('shopify:section:load', initButtons);
  window.addEventListener('load', initButtons);

  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initButtons();
    });
  }
  var observer = new MutationObserver(scheduleInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(initButtons, 800);
  setTimeout(initButtons, 1800);
})();